<template>
  <zpa-form-item
    :error="error"
    :success="success"
    :validating="validating"
    :required="required"
    :readonly="readonly"
    :disabled="disabled"
    :uuid="uuid"
    :span="span"
    :push="push"
    :label="showLabel?label:''"
    :labelWidth="labelWidth"
    :labelAlign="labelAlign"
    :itemHeight="itemHeight"
    :format="format"
    :type="type"
  >
    <DatePicker
      style="width: 100%;border: 1px solid #dcdee2"
      :value="value"
      :placeholder="placeholder || label"
      :editable="false"
      :readonly="readonly"
      :disabled="disabled"
      :options="options"
      :placement="placement"
      :format="format"
      :type="type || type2"
      @on-change="onInputChange"
    />
  </zpa-form-item>
</template>

<script>
import inputMixin from './mixins/input'

export default {
  name: 'zpaDateInput',

  mixins: [inputMixin],
  data () {
    return {
      // startOptions: {
      //   disabledDate (date) {
      //     return date && date.valueOf() < Date.now() - 86400000;
      //   }
      // },

    }
  },
  props: {
    options: Object,
    placement: String,
    type: String,
    type2: String,
    format: String
  }


}
</script>
